import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import SearchResultEntity from "../../../../domain/entities/SearchResultEntity";
import UserEntity, { UserType } from "../../../../domain/entities/UserEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import UserDto from "../../../dto/UserDto";

const SearchUsersApiImpl = async (_:{
    query?: string, page: number, itemsPerPage: number,
    role?: UserType 
}): Promise<Either<ErrorEntity, SearchResultEntity<UserEntity>>> => {
    try {
        let relativeUrl: string = `/users?`;
        if (_.query != undefined && _.query.length > 0) {
            relativeUrl += `user_name=${encodeURIComponent(_.query)}&`;
        }
        if (_.page != undefined) {
            relativeUrl += `page=${_.page}&`;
        }
        if(_.itemsPerPage != undefined){
            relativeUrl += `per_page=${_.itemsPerPage}&`;
        }
        if(_.role != undefined){
            relativeUrl += `user_role=${UserDto.roleToString(_.role)}&`;
        }

        if(relativeUrl.endsWith('&') || relativeUrl.endsWith('?')){
            relativeUrl = relativeUrl.slice(0, -1);
        }

        
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = response.users.data.map((item: any) => UserDto.fromJSON(item));
        return right({
            data: parsed,
            itemsPerPage: response.users.per_page,
            page: response.users.current_page,
            pages: response.users.last_page,
            total: response.users.total,
        })
    } catch (e) {
        return left({ code: "Error" });
    }
}

export default SearchUsersApiImpl;
